import React from "react";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { SingleColumnLayout } from '../../_layouts/SingleColumnLayout';
import { PageHeader } from "../../../designSystem/PageHeader";
import { P } from "../../../designSystem/typography/Body";
import { UserPageWrapper } from "../../_pageWrappers/UserPageWrapper";
import { Card } from "../../../designSystem/Card";

export function UserLandingPage():JSX.Element
{
    return (
        <UserPageWrapper selectedMenuItemKey='dashboard' breadCrumbs={[{ text: 'Overblik', url: '' }]}>
            <PageHeader narrow headerText="Overblik" />
            <SingleColumnLayout narrow>
                <Card variant="outlined">
                    <Flex flexDirection="column" gap={16}>
                        <P>Velkommen som bruger af AMORG</P>

                        <P>Du har begrænset adgang og kan kun se den funktionalitet som du ekspicit er blevet givet adgang til, såsom handleplaner og sikkerhedsrunderinger. Du finder dem via menuen.</P>

                        <P>Hvis du mener, at du burde have adgang til mere funktionalitet, bør du kontakte din AMO gruppe.</P>
                    </Flex>
                </Card>
            </SingleColumnLayout>
        </UserPageWrapper>
    );
}
